import { useState } from 'react';

import Imagem from '../../../images/img-sim.png';
import JubiWinner from '../../../images/asset-jubi-bolsa.png';
import AssetConfetti from '../../../images/asset-confetti-bolsa.gif';
import * as S from './styles';
import { Button } from 'ratel-ui';

const FeedbackHeader = ({ isWinner }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <S.Container>
      {isWinner ? (
        <S.Content isWinner={isWinner}>
          <S.Confetti src={AssetConfetti} alt=""/>
          <S.JubiGif src={JubiWinner} alt="Prof. Jubilut feliz"/>
          <S.TextBox>
            <S.Title isWinner={isWinner}>PARABÉNS!</S.Title>

            <S.WinnerText>
              Você foi um dos ganhadores da
              <strong>BOLSA DE 100% DE DESCONTO</strong>
              para estudar no curso Super Med!
            </S.WinnerText>

            <S.Text isWinner={isWinner}>
              Entre em contato conosco através do e-mail
              <S.LinkClipboard data-clipboard-text="contato@aprovatotal.com.br"
                               onClick={() => setShowTooltip(() => !showTooltip)}>
                contato@aprovatotal.com.br
                {showTooltip && <S.Tooltip showTooltip={showTooltip}>Copiado!</S.Tooltip>}
              </S.LinkClipboard>
              até o dia <strong>19/12/2023</strong> para resgatar o seu prêmio.
            </S.Text>
          </S.TextBox>
        </S.Content>
      ) : (
        <S.Content>
          <S.Rotator src={Imagem} alt=""/>
          <S.Title isWinner={isWinner}>
            AGRADECEMOS A SUA PARTICIPAÇÃO!
          </S.Title>
          <S.Text>
            Você ganhou <strong>RS79 de desconto</strong> para iniciar seus estudos no Super
            MED!<br/>
            Seu cupom de uso único é: {' '}
          </S.Text>

          <S.CouponClipboard data-clipboard-text="TYKL79APROVA"
                             onClick={() => setShowTooltip(() => !showTooltip)}>
            <S.CouponText>CUPOM <strong>TYKL79APROVA</strong></S.CouponText>
            {showTooltip && <S.Tooltip showTooltip={showTooltip}>Copiado!</S.Tooltip>}
          </S.CouponClipboard>

          <S.Text>
            Atenção: seu benefício ficará disponível por 24 horas. <br/>
            Copie o código de cupom e aplique-o no momento da compra para garantir o desconto!
          </S.Text>
          <br/>

          <a
            href="https://aprovatotal.com.br/aprova-medicina/?seller=performance&source=paginas-simulado-supermed-ii&utm_source=paginas-supermed&utm_medium=clique-botao&utm_campaign=venda-supermed2&utm_content=pagina-simulado-supermed2">
            <Button warning large style={{fontWeight: 700}}>
              ASSINE AGORA ➝
            </Button>
          </a>
        </S.Content>
      )}
    </S.Container>
  );
};

export default FeedbackHeader;
